import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DatePipe} from '@angular/common';
import {EventRequete} from '../../../../entities/requete';
import {EventPieceJointe} from '../../../../entities/piece-jointe';
import { saveOrOpenRawFile } from '../../../../shared/core/util';
import {TrackingService} from '../../../../shared/services/tracking.service';
import {TrackingAction, TrackingCategory} from '../../../../shared/model/tracking/tracking.enum';
import {isNullOrUndefined} from 'util';
import {EventPieceService} from './event-piece.service';
import {RequeteService} from '../../../../entities/requete';

@Component({
    selector: 'jhi-timeline-element',
    templateUrl: './timeline-element.component.html',
    styleUrls: ['./timeline-element.component.scss']
})
export class TimelineElementComponent implements OnInit, OnChanges, OnDestroy {


    @Input() mesure: EventRequete;
    @Input() couleurMap: Map<number, string>;
    @Input() juridiction: string;

    isCourrierLu = false;

    private sub: any;
    private dossierId: number;
    private cssStr: string;

    de: string;
    a: string;

    constructor(
        private datePipe: DatePipe,
        private route: ActivatedRoute,
        private trackingService: TrackingService,
        private requeteService: RequeteService,
        public timelineElementService: EventPieceService
    ) {
    }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            this.dossierId = +params['id'];
        });
        this.isCourrierLu = this.isAccuseCourrierLu();

    }

    ngOnChanges(_changes: SimpleChanges): void {
        this.getDirection();
    }

    getDirection() {
        // evenement TRC
        if (this.mesure.isTrc) {
            if (this.mesure.direction === 'ENVOYE') {
                this.de = this.juridiction;
                this.a = this.mesure.nomActeur;
                this.cssStr = 'communication-juridiction';

            } else {
                this.de = this.mesure.nomActeur;
                this.a = this.juridiction;
                if (this.mesure.acteurIdTr) {
                    this.cssStr = this.couleurMap.get(Number(this.mesure.acteurIdTr));
                } else {
                    this.cssStr = 'lecteur';
                }

            }
        } else {
            // evenement TR
            this.de = this.juridiction;
            this.a = this.mesure.nomActeur;
            this.cssStr = 'communication-juridiction';
        }

    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    convertTime(dateInput: Date): string {
        const dateArray = dateInput.toString().split('T');
        if (dateArray[1] === '00:00:00') {
            return null;
        } else {
            const timeArray = dateArray[1].split(':');
            return `${timeArray[0]}:${timeArray[1]}`;
        }
    }

    downloadFile(eventId: number, eventType: string, fichier: EventPieceJointe) {
        if (this.isAccuseCourrier() && isNullOrUndefined(this.mesure.dateReception)) {
            this.notifyAccuseCourrier();
        }

        this.trackDownloadedFile(fichier);

        this.timelineElementService.downloadEventPieceFile(this.dossierId, eventId, eventType,
            fichier.fileApiId, fichier.libelle, fichier.origin, {responseType: 'blob'})
            .subscribe( blob => {
                const fileN = !/(.+)(\.pdf)+$/.test(fichier.libelle) ?
                `${fichier.libelle}.pdf` :
                fichier.libelle;
                saveOrOpenRawFile(blob, fileN);
            });
    }

    getClass(): string {
        return this.cssStr;
    }

    isAccuseCourrierLu() {
        return this.isAccuseCourrier() && this.mesure.dateReception != null;
    }

    isAccuseCourrier() {
        return this.mesure.pieces.some(piece => piece.fileType === 'NCOU');
    }

    notifyAccuseCourrier() {
        this.requeteService.notifyAccuseCourrier(this.dossierId, this.mesure.id, null).subscribe(
            res => {
                this.isCourrierLu = true;
                this.mesure.dateReception = res;
            }
        );
    }

    formatDate(date: Date) {
        if ((date.getHours() === 0) && (date.getMinutes() === 0)) {
            return this.datePipe.transform(date, 'dd/MM/yyyy');
        } else {
            return this.datePipe.transform(date, 'dd/MM/yyyy à HH:mm:ss');
        }
    }

    getFichier() {
        if (this.mesure.pieces && this.mesure.pieces.length > 0) {
            return this.mesure.pieces.filter(piece => piece.fileType !== 'POSTALE');
        }
        return null;
    }

    private trackDownloadedFile(fichier: EventPieceJointe) {
        this.trackingService.trackEvent({
            action: TrackingAction.DOWNLOAD,
            properties: {
                category: TrackingCategory.CONSULTATION_DOSSIER,
                name: `Type de fichier : ${fichier.fileType}`
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/requete/historique-requete/timeline/timeline-element/timeline-element.component.ts